import {Injectable} from '@angular/core';
import {SignalrService} from './signalr/signalr.service';

@Injectable()
export class IdleStateService {

  private readonly INTERVAL = 60 * 1000;
  private readonly RELOAD_TIMEOUT = 10 * 60 * 1000;

  private lastTimestamp: Date = new Date();

  constructor(public signalR: SignalrService) {
  }

  public init() {
    setInterval(() => {
      const now: Date = new Date();
      const timeSinceLastCheck = now.getTime() - this.lastTimestamp.getTime();
      if (timeSinceLastCheck > this.RELOAD_TIMEOUT) {
        window.location.reload(true);
      }
      if (navigator.onLine && this.signalR.state === 0) {
        console.log(timeSinceLastCheck + 'ms since last check..');
        this.lastTimestamp = now;
      }
    }, this.INTERVAL);
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/idle-state.service.ts